import { render, staticRenderFns } from "./TextImageModule.vue?vue&type=template&id=1f6439f2&"
import script from "./TextImageModule.ts?vue&type=script&lang=ts&"
export * from "./TextImageModule.ts?vue&type=script&lang=ts&"
import style0 from "./TextImageModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports